import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ListItemButtonStyled, StyledTextLabel, StyledItemText } from './styles/SettingsListStyled';

class ListItemButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { onClick, label, title } = this.props;
    return (
      <ListItemButtonStyled onClick={onClick}>
        <StyledTextLabel color="white" type="capitalize" size="fs_s" font="din_medium">
          {label}
          :&nbsp;
        </StyledTextLabel>
        <StyledItemText color="blue_doger" type="elipses" font="din_medium" size="xs">
          {title}
        </StyledItemText>
      </ListItemButtonStyled>
    );
  }
}

ListItemButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  label: PropTypes.string,
};

ListItemButton.defaultProps = {
  onClick: Function.prototype,
  title: '',
  label: '',
};

export default ListItemButton;
